import { ConfigurationContext } from "components/provider/OrginazationContext";
import { useContext } from "react";
import { ActionType } from "utils/action.type.enum";

interface PermissionWrapperProps {
  children: React.ReactNode;
  module_code: string;
  actionType: ActionType
}

const PermissionWrapper = ({
    children,
  actionType,
  module_code,
}: PermissionWrapperProps) => {
  const { permission } = useContext(ConfigurationContext);

  const modulePermission = permission?.find(
    (item: any) => item.module_code === module_code
  );

  const hasPermission =  modulePermission
    ? modulePermission[actionType]
    : true;

  if (!hasPermission) {
    return null;
  }

  return <>{children}</>;
};

export default PermissionWrapper;